import '../../styles/index.styl'
import React from 'react'
import { Route } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
// Partials
import SideMenu from '../side_menu'
// Routes
import Dashboard from '../dashboard'
import Customers from '../customers'
import Credentials from '../credentials'
import ProjectsList from '../projects/list'
import ProjectsCreate from '../projects/create'
import Login from '../login'

export default class UIComponent extends React.Component {
  componentWillReceiveProps (nextProps) {
    const { path, loggedIn, navigate } = this.props

    if (loggedIn === false && nextProps.loggedIn === true) {
      // We are transitioning from logged out to logged in. Navigate to dashboard
      // @NOTE: this is in place to prevent the bug where the user sees an empty edit screen. That bug needs fixing.
      console.log('PATH', path)

      if (typeof path === 'string' && path.includes('customers')) {
        return navigate('/customers')
      }

      if (typeof path === 'string' && path.includes('projects')) {
        return navigate(path)
      }

      if (typeof path === 'string' && path.includes('credentials')) {
        return navigate('/credentials')
      }

      navigate('/')
    }
  }

  render () {
    const { loggedIn, loggingIn } = this.props
    let content = null

    if (loggedIn === false && loggingIn === true) {
      content = (
        <section className='application' style={{ textAlign: 'center', width: '100%', display: 'block' }}>
          <div className='main-paine' style={{ textAlign: 'center', width: '100%', display: 'block' }}>
            <center style={{ textAlign: 'center', width: '100%', display: 'block' }}>
              <h3 style={{ color: '#999', marginTop: '100px', textAlign: 'center', width: '100%', display: 'block' }}>Momentje...</h3>
            </center>
          </div>
        </section>
      )
    }

    if (loggedIn === true) {
      content = (
        <section className='application'>
          <div className='main-pane'>
            <Route path='/' component={Dashboard} exact />
            <Route path='/customers' component={Customers} exact />
            <Route path='/projects' component={ProjectsList} exact />
            <Route path='/projects/edit/:id' component={ProjectsCreate} exact />
            <Route path='/credentials' component={Credentials} exact />
          </div>
          <SideMenu />
        </section>
      )
    }

    if (content === null) {
      content = (
        <section className='application'>
          <div className='main-pane'>
            <Route path='/' component={Login} />
          </div>
        </section>
      )
    }

    return (
      <ConnectedRouter history={this.props.history}>
        {content}
      </ConnectedRouter>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/app/component.js